import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Link as Link$2 } from '@chakra-ui/react';
import { withTooltip } from '../../hoc/with-tooltip.js';
var _excluded = ["children", "textStyle"];
var Link = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    textStyle = props.textStyle,
    rest = _objectWithoutProperties(props, _excluded);
  /**
   * DOM
   * */
  return /*#__PURE__*/React.createElement(Link$2
  // @ts-ignore NOTE: tech-debt
  , _extends({
    ref: ref,
    "data-object-type": "core-link",
    textStyle: textStyle
  }, rest), children);
});
Link.displayName = 'Link';
var Link$1 = withTooltip('CoreLink')(Link);
export { Link, Link$1 as default };